jQuery( document ).ready(function() {

    // Initialize Tiny Slider
    jQuery(".tiny-slider.tiny-slider-logos").each(function() {
        var sliderId = jQuery(this).data('slider');
        var currentSlider = jQuery('.tiny-slider.tiny-slider-logos.'+sliderId).parents('.logos-container');
        var photoGallerySlider = tns({
            container: '.tiny-slider.tiny-slider-logos.'+sliderId,
            autoWidth: true,
            items: 1,
            slideBy: 1,
            gutter: 60,
            autoplay: true,
            controls: false,
            nav: false,
            autoplayButtonOutput: false,
            center: true
        });
    });

});